import _sfc_main from "./NotificationListItem.vue2.js";
/* empty css                          */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const NotificationListItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b659cfeb"]]);
export {
  NotificationListItem as default
};
//# sourceMappingURL=NotificationListItem.vue.js.map
